import { Eye, EyeSlash } from "@phosphor-icons/react";
import classNames from "classnames";
import { forwardRef, useState } from "react";
import { Input, InputProps } from "./Input";

export interface PasswordInputProps
  extends Omit<InputProps, "type" | "endComponent"> {}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ variant = "primary", ...props }, ref): JSX.Element => {
    const [isHidden, setIsHidden] = useState(true);

    function handleToggleVisibility() {
      setIsHidden(hidden => !hidden);
    }

    const Icon = isHidden ? Eye : EyeSlash;

    return (
      <Input
        ref={ref}
        variant={variant}
        {...props}
        type={isHidden ? "password" : "text"}
        endComponent={
          <button
            type="button"
            title={isHidden ? "Ver" : "Esconder"}
            onClick={handleToggleVisibility}
            className={classNames(
              "rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-app-blue-500",
              variant === "tertiary"
                ? "text-app-gray-800 hover:bg-app-gray-300/10"
                : "text-white hover:bg-app-gray-300/50",
            )}
          >
            <Icon size={18} />
          </button>
        }
      />
    );
  },
);
